import { type TCoreButtonViewProps } from '@core/widgets';
import { useBehavior, useButton, useTriggerAction } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TButtonRowEmphasised } from '../../types/data';
import { TRowOption } from '../../types/options';
import { RowEmphasisedView } from './RowEmphasisedView';

export const RowEmphasised = ({ widget }: TWidgetProps<TButtonRowEmphasised, TRowOption>) => {
    const data = widget.data ?? {};
    const { isDisabled, isHidden } = useBehavior(widget);
    const { triggerActionsByType, triggerActionsByNameAndType } = useTriggerAction(widget);
    const { handleClick } = useButton(widget, { isDisabled, triggerActionsByType, triggerActionsByNameAndType });
    const expiredOrDisabled = data.expired ?? isDisabled ?? false;
    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    return (
        <RowEmphasisedView
            widget={widget as TCoreButtonViewProps['widget']}
            uid={widget.uid}
            title={data.messages?.title}
            subtitle={data.messages?.subtitle}
            meta={data.messages?.meta}
            iconName={data.iconName}
            avatar={data.avatar}
            metaVariant={widget.options?.metaVariant}
            isDisabled={isDisabled}
            isContentDisabled={expiredOrDisabled}
            isHide={isHidden}
            margin={widget.options?.margin}
            parentStyleNames={parentStyleNames}
            onClick={handleClick}
        />
    );
};
